import { createBasicSelector } from 'util/redux'
import { isUnread } from '../utils/state'
import { selectCurrentConversationById } from '.'

export const selectConversationIsUnreadByConversationId = createBasicSelector(
  selectCurrentConversationById,
  ticket => isUnread(ticket)
)
